type Experiment = {
  headline: string;
  subHeadline: string;
  body: string;
  button: string;
};

const experiments: Record<string, Experiment> = {
  subscription: {
    headline: "You're on the list!",
    subHeadline: 'Thanks for your interest in the new Swyftx subscription.',
    body: "We're currently working on this new feature to ensure it provides the best value for our active traders. Because you've shown interest, you've been added to our notification list. You'll be among the first to know the moment it goes live. We appreciate your feedback!",
    button: 'Go back to Swyftx',
  },
};

export { experiments };
